import { render } from "./fantan-list-item.vue?vue&type=template&id=fa14095e&scoped=true&ts=true"
import script from "./fantan-list-item.vue?vue&type=script&lang=ts"
export * from "./fantan-list-item.vue?vue&type=script&lang=ts"

import "./fantan-list-item.vue?vue&type=style&index=0&id=fa14095e&lang=scss&scoped=true"

import exportComponent from "D:\\project\\fantan\\h5\\fantan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa14095e"]])

export default __exports__